import loadable from '@loadable/component'

import HttpStatus from 'components/Common/HttpStatus'
import Error404PageWithOffers from 'components/Pages/Error404PageWithOffers/Error404PageWithOffers'
import LocaleAwareRoute, { LocaleAwareSwitch } from 'components/App/Routes/LocaleAwareRoute'

const HeaderMain = loadable(
  () =>
    import(
      '../../client/components/App/Header/HeaderMain/HeaderMain'
    ),
)

function Trip404Page() {
  return (
    <LocaleAwareSwitch>
      <LocaleAwareRoute exact path="/:regionCode/trip-planner/trip">
        <HttpStatus code={404}>
          <HeaderMain />
          <Error404PageWithOffers />
        </HttpStatus>
      </LocaleAwareRoute>
      <LocaleAwareRoute>
        <HttpStatus code={404}>
          <Error404PageWithOffers />
        </HttpStatus>
      </LocaleAwareRoute>
    </LocaleAwareSwitch>
  )
}

export default Trip404Page
